<template>
  <div class="sub-tarefa-inputs-pai">
    <div class="sub-tarefa-inputs">
      <div class="sub-tarefa-inputs-top">
        <h6>Confirmação</h6>
        <h6
          style="cursor: pointer"
          @click="fecharModal()"
        >
          X
        </h6>
      </div>
      <div class="sub-tarefa-all-inputs">
        <h4>{{ texto }}</h4>
        <div class="btns">
          <button
            type="button"
            class="sub-tarefa-btn"
            @click="confirmacaoFuncao(true)"
          >
            Sim
          </button>
          <button
            type="button"
            class="sub-tarefa-btn"
            @click="confirmacaoFuncao(false)"
          >
            Não
          </button>
          <!-- <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-if="sucesso == true"
          >
            <i
              class="fa-solid fa-circle-check fa-5x"
              style="color: #27d41b"
            ></i>
            <h4>{{ texto }}</h4>
          </div>
          <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-if="sucesso == false"
          >
            <i
              class="fa-sharp fa-solid fa-circle-exclamation fa-5x"
              style="color: #ff0000"
            ></i>
            <h4>{{ texto }}</h4>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  texto: String,
});
const confirmacao = ref(false);
const emit = defineEmits(["confirmacao"]);
function confirmacaoFuncao(valor) {
  confirmacao.value = valor;
  fecharModal();
}
function fecharModal() {
  emit("confirmacao", confirmacao.value);
}
</script>

<style scoped>
.sub-tarefa-inputs-pai {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.sub-tarefa-btn {
  padding: 8px 25px;
  background-color: var(--azul-escuro);
  color: var(--branco);
  border-radius: 5px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.sub-tarefa-btn:hover {
  background-color: var(--roxo-escuro);
}

.sub-tarefa-inputs {
  background-color: var(--branco);
  border: none;
  border-radius: 15px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: var(--azul-escuro);
  border-radius: 15px 15px 0 0;
  padding: 15px 0;
  position: relative;
  min-height: 50px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: var(--branco);
  font-weight: bold;
  margin: 0;
  text-align: center;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 30px;
  border-radius: 0px 15px 0px 0px;
  background-color: var(--vermelho);
  color: var(--branco);
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 100%;
}
.sub-tarefa-all-inputs {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.btns {
  display: flex;
  flex-direction: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  gap: 10px;
}
.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
